import { Box, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const StatusIconWithTooltip = ({ icon, tooltipContent }) => {
    if (null === icon) {
        return null;
    }

    if (!tooltipContent) {
        return <Box sx={{ pr: '5px' }}>{icon}</Box>;
    }

    const tooltipTitle = <Typography sx={{ whiteSpace: 'pre-line', fontSize: '11px', lineHeight: '16px' }}>{tooltipContent}</Typography>;

    return (
        <Tooltip title={tooltipTitle}>
            <Box sx={{ pr: '5px' }}>{icon}</Box>
        </Tooltip>
    );
};

StatusIconWithTooltip.propTypes = {
    icon: PropTypes.element,
    tooltipContent: PropTypes.string,
};

export default StatusIconWithTooltip;
